/** 파일 기능 슬라이스 — 블록 직렬화만(라운드트립 유지). 슬래시 제외(blocknote 동작 일치). */
import { fileBlockToElement, fileElementToBlock } from "./file.js";

export default {
  name: "file",
  blocks: { file: { toElement: fileBlockToElement, fromElement: fileElementToBlock } },
  // 슬래시 없음 — 일반 파일은 blocknote도 슬래시 미노출(파일 블록 렌더/직렬화만 유지)
};
